"use strict";

class PropertyReportsController {
    constructor(
        $window,
        $http,
        SSHttpService,
        SSUtilService,
        SSAlertService,
        SSConfigService,
        SSUserService,
        SSConfirmationService,
        $timeout
    ) {
        const self = this;

        self.$window = $window;
        self.$timeout = $timeout;
        self.$http = $http;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.SSConfigService = SSConfigService;
        self.SSUserService = SSUserService;
        self.SSConfirmationService = SSConfirmationService;

        self.data = SHOWSUITE.data;
        self.parameters = self.data.url_param;
        self.SALE_STATUS_ABORTED = SHOWSUITE.SALE_STATUS_ABORTED;

        self.LARAVEL_REPORT_SERVER_URL = SHOWSUITE.LARAVEL_REPORT_SERVER_URL;

        self.INSTRUMENT_TYPE_CHEQUE = SHOWSUITE.INSTRUMENT_TYPE_CHEQUE;
        self.INSTRUMENT_TYPE_CASHIERS_ORDER = SHOWSUITE.INSTRUMENT_TYPE_CASHIERS_ORDER;
        self.INSTRUMENT_TYPE_TELEGRAPHIC_TRANSFER = SHOWSUITE.INSTRUMENT_TYPE_TELEGRAPHIC_TRANSFER;
        self.INSTRUMENT_TYPE_CASH_IN = SHOWSUITE.INSTRUMENT_TYPE_CASH_IN;
        self.INSTRUMENT_TYPE_GIRO = SHOWSUITE.INSTRUMENT_TYPE_GIRO;
        self.INSTRUMENT_TYPE_FAST_CASH = SHOWSUITE.INSTRUMENT_TYPE_FAST_CASH;
        self.INSTRUMENT_TYPE_BANK_TRANSFER = SHOWSUITE.INSTRUMENT_TYPE_BANK_TRANSFER;
        self.INSTRUMENT_TYPE_PAYNOW_OTHERS = SHOWSUITE.INSTRUMENT_TYPE_PAYNOW_OTHERS;
        self.INSTRUMENT_TYPE_CASH = SHOWSUITE.INSTRUMENT_TYPE_CASH;
        self.INSTRUMENT_TYPE_EDP = SHOWSUITE.INSTRUMENT_TYPE_EDP;
        self.INSTRUMENT_TYPE_EDP_PLUS = SHOWSUITE.INSTRUMENT_TYPE_EDP_PLUS;

        self.BUYER_LIST_REPORT = 1;
        self.COMMISSION_LISTING_REPORT = 2;
        self.LIST_OPTION_ISSUED_REPORT = 3;
        self.SALES_RECEIVABLES_REPORT = 4;
        self.SALES_SUMMARY_REPORT = 5;
        // self.URA_REPORT = 6;
        self.URA_REPORT = 70;
        self.URA_REPORT_NEW = 71;
        self.SALES_STATUS_REPORT = 7;
        self.DMS_REPORTS_SALE_REISSUE = 32;
        self.offset = 0;
        self.limit = 1000;
        self.archive_count = null;
        self.report = false;
        self.reportType = null;
        self.archive = null;
        self.firstVal = "";
        self.date = "bank_in_date";
        self.property_account_id = null;
        self.property_bank_in_date = null;
        self.unit_no_filter = "";
        self.sortField = null;
        self.sortReverse = false;

        /*
         * Client-side filter for the ICL/BIL results table — matches the user's
         * input against either the unit number or the OTP number on each row.
         * Defined here as a closure so it can be passed directly to AngularJS's
         * `filter:` filter (which calls the function without binding `this`).
         */
        self.unitOrOtpFilter = function (entry) {
            if (!self.unit_no_filter) return true;
            var q = String(self.unit_no_filter).toLowerCase();
            return (String(entry.unit || '').toLowerCase().indexOf(q) !== -1)
                || (String(entry.otp || '').toLowerCase().indexOf(q) !== -1);
        };

        self.allReportStatus = [
            {
                id: 11,
                name: "All",
            },
            {
                id: 30,
                name: "OTP Issued",
            },
            {
                id: 32,
                name: "SPA Issued",
            },
            {
                id: 37,
                name: "Exercised",
            },
            {
                id: 35,
                name: "OTP Aborted",
            },
        ];

        self.paymentTypes = [
            { id: self.INSTRUMENT_TYPE_CHEQUE, name: "CHEQUE", allowed: true },
            { id: self.INSTRUMENT_TYPE_CASHIERS_ORDER, name: 'CASHIERS\' ORDER', allowed: true },
            { id: self.INSTRUMENT_TYPE_TELEGRAPHIC_TRANSFER, name: 'TT', allowed: true },
            { id: self.INSTRUMENT_TYPE_BANK_TRANSFER, name: "BANK TRANSFER", allowed: true },
            { id: self.INSTRUMENT_TYPE_PAYNOW_OTHERS, name: "PAYNOW", allowed: true },
            { id: self.INSTRUMENT_TYPE_FAST_CASH, name: 'FAST CASH', allowed: true },
            { id: self.INSTRUMENT_TYPE_CASH_IN, name: 'CASH-IN', allowed: true },
            { id: self.INSTRUMENT_TYPE_CASH, name: 'CASH', allowed: true },
            { id: self.INSTRUMENT_TYPE_GIRO, name: 'GIRO', allowed: true },
            { id: self.INSTRUMENT_TYPE_EDP, name: 'EDP', allowed: true },
            { id: self.INSTRUMENT_TYPE_EDP_PLUS, name: 'EDP+', allowed: true },
        ];

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.property_ids = [];
        self.all_project = 1;

        self.property_id = null;
        self.child = [];
        self.banks = self.SSConfigService.getBanks();

        /* WEB-2829 DMS > Select Project drop down
        * Timeout added to make getAllProperties call after getReport call so loading doesn't get hidden */
        self.$timeout(function () {
            self.getAllProperties();
        }, 1200);

        //self.reportType = null;
        if (self.data.icl_report || self.data.bil_report) {
            self.report = true;
            if (self.data.icl_report) self.reportType = "icl";
            if (self.data.bil_report) self.reportType = "bil";
            self.prepareBanksData();
            self.loadSortState();
        }
        if (self.data.archive) {
            self.archive = self.data.archive;
        }
        if (self.report && self.reportType != null) {
            self.getICLReportData();
        }
        if (self.archive) {
            self.getICLReportArchiveData();
        }
    }

    prepareBanksData() {
        const self = this;

        let banks_master = angular.copy(self.SSConfigService.getBanks());

        self.banks = [];
        jQuery.each(banks_master, function (i, bank) {
            if(bank.name.toLowerCase() !== 'others')
                self.banks.push(bank);
        });
    }

    getProperty() {
        const self = this;

        if (!self.data.property_id) return;

        self.property = null;
        self.propertyParams = null;
        self.property_id = self.data.property_id;
        let url = "sec/developer/properties/" + self.property_id;

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.property = response.data.property;
            self.getAllProperties();
        });
    }

    getAllProperties() {
        const self = this;
        self.propertyFormat = [];

        // `properties/customized` is a generic endpoint and is NOT auto-scoped
        // to the current user's developer. We must pass `developer_id` explicitly
        // — otherwise the dropdown lists projects from every developer on the
        // platform (regression introduced by WEB-3384). The current user's
        // developer_id is not on the user object in localStorage, so fetch it
        // from `sec/developer/profile` once and cache it on the controller.
        if (self.currentDeveloperId) {
            self.fetchAllPropertiesForDeveloper();
            return;
        }

        loading(true);
        self.SSHttpService.getAPIRequest('sec/developer/profile').then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response && response.data && response.data.developer && response.data.developer.id) {
                self.currentDeveloperId = response.data.developer.id;
            }

            self.fetchAllPropertiesForDeveloper();
        });
    }

    /**
     * Fetch the property list for the current developer using the lightweight
     * `properties/customized` endpoint. Always called via `getAllProperties()`
     * so `self.currentDeveloperId` is guaranteed to be resolved (or attempted)
     * before this runs.
     */
    fetchAllPropertiesForDeveloper() {
        const self = this;

        let params = {
            offset: 0,
            limit: 1000,
            property_selected_fields: 'id,name,named_id'
        };
        if (self.currentDeveloperId) {
            params.developer_id = self.currentDeveloperId;
        }

        loading(true);
        self.SSHttpService.getAPIRequest('properties/customized', params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.allProperties = response.data.properties;

            jQuery.each(self.allProperties, function (i, property) {
                self.propertyFormat.push({
                    id: property.id,
                    label: property.name,
                });
            });

            self.getReportSettings();
        });
    }

    downloadReport(reportType, id) {
        const self = this;
        self.selected_report = reportType;
        self.generateReport = {
            report_id: id,
            properties: self.propertyFormat,
            report_property: [],
        };
        self.currentReportConfig = {
            url: self.SSHttpService.getApiURL("sec/developer/properties/reports/bil/export"),
            showDateRange: true,
            showStatus: true,
            allowMultipleProperties: false,
            permission: reportType,
        };
        self.reportStatuses = self.allReportStatus;
        self.hideModals();
        self.$timeout(function () {
            $("select.dashboard-select").niceSelect("update");
            jQuery(".datepicker2").datepicker({
                changeMonth: true,
                changeYear: true,
                yearRange: "1900:+0",
                dateFormat: "dd/mm/yy",
            });
        });
        self.downloadReportModal = true;
        $("#downloadReportModal").modal("show");
    }

    reportSettings(reportType, id) {
        const self = this;
        self.selected_report = id;
        self.reportSchedule = {};
        self.property_ids = [];
        self.hideModals();

        jQuery.each(self.reportSchedules, function (i, report) {
            if (report.id == id) {
                self.reportSchedule = JSON.parse(report.value);
            }
        });

        if (self.reportSchedule.property_ids) {
            self.reportSchedule.property_ids =
                self.reportSchedule.property_ids.split(",");
        }
        jQuery.each(self.reportSchedule.property_ids, function (i, property) {
            var propertyName = self.propertyFormat.find(function (x) {
                return x.id == property;
            });
            self.property_ids.push(propertyName);
        });
        self.showReportSettings();
    }

    showReportSettings() {
        const self = this;
        self.reportSchedule.enable_button = true;
        self.reportSettingsModal = true;
        $("#reportSettingsModal").modal("show");
    }

    validateEmail(mail) {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w {2, 3})+$/.test(mail)) {
            return true;
        }
        return false;
    }

    hideModals() {
        const self = this;

        self.downloadReportModal = false;
        self.reportSettingsModal = false;
        self.downloadIclReportModal = false;

        if ($("#downloadReportModal").is(":visible"))
            $("#downloadReportModal").modal("hide");
        if ($("#reportSettingsModal").is(":visible"))
            $("#reportSettingsModal").modal("hide");
        if ($("#downloadIclReportModal").is(":visible"))
            $("#downloadIclReportModal").modal("hide");
        if($("#generatePDFModal").is(":visible"))
            $("#generatePDFModal").modal("hide");
    }

    confirmDownloadReport() {
        const self = this;
        self.generateReportErrors = {};
        let url = "";
        let url_ping = "";
        let from_date = "";
        let to_date = "";

        var download_report_property_ids = [];
        jQuery.each(
            self.generateReport.report_property,
            function (i, property) {
                download_report_property_ids.push(property.id);
            }
        );
        if (
            typeof download_report_property_ids !== "undefined" &&
            download_report_property_ids.length < 1
        ) {
            download_report_property_ids.push("");
        }

        if (self.generateReport.from_date) {
            from_date = moment(
                self.generateReport.from_date,
                "DD-MM-YYYY"
            ).format("YYYY-MM-DD");
        }

        if (self.generateReport.to_date) {
            to_date = moment(self.generateReport.to_date, "DD-MM-YYYY").format(
                "YYYY-MM-DD"
            );
        }
        jQuery.each(download_report_property_ids, function (i, property_id) {
            if (
                !self.validateReportGenerate(self.generateReport.report_id) ||
                !self.generateReport.report_id ||
                !self.currentReportConfig
            ) {
                return;
            }

            url = self.currentReportConfig.url;
            if (url) {
                url += url.indexOf("?") > -1 ? "&" : "?";
            }

            if (self.currentReportConfig.allowMultipleProperties) {
                url += "property_ids=" + download_report_property_ids;
            } else {
                url += "property_id=" + property_id;
            }

            url += "&from_date=" + from_date;
            url += "&to_date=" + to_date;
            if (self.currentReportConfig.showStatus) {
                url += "&status=" + self.generateReport.report_status;
            }
            url += '&offset=0&limit=1000&order={"eoi_no":"asc"}';

            url_ping = window.open(url, "_blank");
        });
        if (url_ping) {
            self.SSAlertService.success(
                "Success!",
                "Download completed successfully"
            );
        }
        self.hideModals();
    }

    saveReportSettings() {
        const self = this;

        if (!self.selected_report) {
            return;
        }

        var saveSchedule = {};

        if (self.reportSchedule.enable_button) {
            saveSchedule.frequency = self.reportSchedule.frequency;
            saveSchedule.target_emails = self.reportSchedule.target_emails;
            saveSchedule.property_ids = [];
            jQuery.each(self.property_ids, function (i, property) {
                saveSchedule.property_ids.push(property.id);
            });
            saveSchedule.property_ids = saveSchedule.property_ids.toString();
        } else {
            saveSchedule.frequency = "";
            saveSchedule.target_emails = "";
            saveSchedule.property_ids = "";
        }

        let url = "sec/report/report-schedules";

        let params = {
            id: self.selected_report,
            value: saveSchedule,
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (
            response
        ) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            var reportScheduleSaved = response.data.developer_settings;
            jQuery.each(self.reportSchedules, function (i, report) {
                if (report.id == reportScheduleSaved.id) {
                    self.reportSchedules[i] = reportScheduleSaved;
                    return;
                }
            });

            self.hideModals();
            self.SSAlertService.success(
                "Success!",
                "Report settings saved successfully"
            );
        });
    }
    getReportSettings() {
        const self = this;

        let url = "sec/report/report-schedules";

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.reportSchedules = response.data.developer_settings;
        });
    }
    validateReportGenerate(id) {
        const self = this;

        let form_clean = true;
        if (!self.currentReportConfig) {
            return false;
        }

        if (self.currentReportConfig.showDateRange) {
            if (
                !self.generateReport.hasOwnProperty("from_date") ||
                self.generateReport.from_date == "" ||
                self.generateReport.from_date == undefined
            ) {
                self.generateReportErrors.from_date = "Please select From Date";
                form_clean = false;
            }

            if (
                !self.generateReport.hasOwnProperty("to_date") ||
                self.generateReport.to_date == "" ||
                self.generateReport.to_date == undefined
            ) {
                self.generateReportErrors.to_date = "Please select To Date";
                form_clean = false;
            }

            if (self.currentReportConfig.showStatus) {
                if (
                    !self.generateReport.hasOwnProperty("report_status") ||
                    self.generateReport.report_status == "" ||
                    self.generateReport.report_status == undefined
                ) {
                    self.generateReportErrors.report_status =
                        "Please select Status";
                    form_clean = false;
                }
            }

            if (
                !self.generateReport.hasOwnProperty("report_property") ||
                self.generateReport.report_property == "" ||
                self.generateReport.report_property == undefined
            ) {
                if (self.generateReport.report_property.length === 0) {
                    self.generateReportErrors.report_property =
                        "Please select property";
                    form_clean = false;
                }
            }
        }

        return form_clean;
    }

    getICLReportData() {
        const self = this;
        if (!self.reportType) return;
        self.$timeout(function () {
            jQuery(".datepicker").datepicker({
                changeMonth: true,
                changeYear: true,
                yearRange: "1900:+0",
                dateFormat: "yy-mm-dd",
            });
            jQuery(".datepicker2").datepicker({
                changeMonth: true,
                changeYear: true,
                yearRange: "1900:+0",
                dateFormat: "dd-mm-yy",
            });
        });
        self.report_data = null;
        self.last_generated_date = null;
        if (!self.property_id) {
            self.property_id = self.data.property_id;
        }

        let types = [];
        jQuery.each(self.paymentTypes, function (index, paymentType){
            if(paymentType.allowed){
                types.push(paymentType.id);
            }
        });

        let url = "sec/developer/properties/reports/" + self.reportType;

        let params = {
            offset: self.offset,
            limit: self.limit,
            count: true,
            property: self.property_selected,
            report: self.reportType,
            from_date: self.property_selected_from_date,
            to_date: self.property_selected_to_date,
            date: self.date,
            types: JSON.stringify(types),
            property_account_id: self.property_account_id
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.report_data = response.data.report_data;
            if (self.report_data) loading(false);
            self.property_list = response.data.properties;
            var count = 0;
            $.each(self.property_list, function (key, value) {
                count++;
                if (key == "") delete self.property_list[key];
                if (count == 2) self.firstVal = key;
            });
            //self.property_selected = self.firstVal;
            self.last_generated_date = response.data.last_date;
            //if(self.property_selected == '')
            //    self.property_selected = self.firstVal;
            //else
            self.property_selected = response.data.selected_property;
            self.getPropertyAccountsData();
        });
    }

    reset() {
        const self = this;

        self.property_selected = self.firstVal;
        self.property_selected_from_date = "";
        self.property_selected_to_date = "";
        self.date = "bank_in_date";
        self.property_account_id = null;
        self.unit_no_filter = "";
        self.sortField = null;
        self.sortReverse = false;
        self.saveSortState();

        $.each(self.paymentTypes,function(index,paymentType){
            paymentType.allowed = true;
        });

        self.getICLReportData();
    }

    /**
     * Toggle the active client-side sort field for the ICL/BIL results table.
     *
     * Clicking the same column flips ascending/descending; clicking a new column
     * sets it as the sort field and resets direction to ascending.
     *
     * @param {string} field Property name on the report row (e.g. 'unit', 'otp_date').
     */
    toggleSort(field) {
        const self = this;
        if (self.sortField === field) {
            self.sortReverse = !self.sortReverse;
        } else {
            self.sortField = field;
            self.sortReverse = false;
        }
        self.saveSortState();
    }

    /**
     * Resolve the FontAwesome 4 icon class for the sort indicator on a sortable
     * column header. Inactive columns show a faded `fa-sort` glyph so users can
     * see at a glance which columns are sortable; the active column shows a
     * directional arrow.
     *
     * @param {string} field Property name on the report row.
     * @returns {string} Space-separated FA classes for `ng-class`.
     */
    sortIconClass(field) {
        const self = this;
        if (self.sortField !== field) return 'fa-sort text-muted';
        return self.sortReverse ? 'fa-sort-desc' : 'fa-sort-asc';
    }

    /**
     * localStorage key used to persist the active client-side sort for the
     * current report type. ICL and BIL keep their own state.
     *
     * @returns {string|null} Storage key, or null if no report type is set.
     */
    sortStorageKey() {
        const self = this;
        if (!self.reportType) return null;
        return 'reports.' + self.reportType + '.sort';
    }

    /**
     * Restore the previously-applied sort field/direction from localStorage so
     * the user's last sort preference survives page reloads. Silently no-ops
     * if storage is unavailable or the saved payload is malformed.
     */
    loadSortState() {
        const self = this;
        const key = self.sortStorageKey();
        if (!key) return;
        try {
            const raw = localStorage.getItem(key);
            if (!raw) return;
            const parsed = JSON.parse(raw);
            if (parsed && typeof parsed.field === 'string') {
                self.sortField = parsed.field;
                self.sortReverse = !!parsed.reverse;
            }
        } catch (e) {
            /* localStorage blocked or payload corrupt — fall back to defaults */
        }
    }

    /**
     * Persist (or clear) the active sort field/direction in localStorage.
     * Called whenever `toggleSort` flips the state and after `reset` clears it.
     */
    saveSortState() {
        const self = this;
        const key = self.sortStorageKey();
        if (!key) return;
        try {
            if (!self.sortField) {
                localStorage.removeItem(key);
            } else {
                localStorage.setItem(
                    key,
                    JSON.stringify({ field: self.sortField, reverse: self.sortReverse })
                );
            }
        } catch (e) {
            /* localStorage blocked — sort just won't persist this session */
        }
    }

    getICLReportArchiveData() {
        const self = this;
        if (!self.archive) return;
        self.report_archive_data = null;
        if (!self.property_id) {
            self.property_id = self.data.property_id;
        }
        let url =
            "sec/developer/properties/reports/" + self.archive + "/archives";
        let params = {
            offset: self.offset,
            limit: self.limit,
            count: true,
            selected_property: self.property_selected,
        };
        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            loading(false);
            self.report_archive_data = response.data.report_archive_data;
            self.archive_count = response.data.count;
        });
    }

    downloadICLArchiveReport(id) {
        const self = this;
        if (!id) {
            return;
        }
        if (!self.property_id) {
            self.property_id = self.data.property_id;
        }
        let url = self.SSHttpService.getApiURL(
            "sec/developer/properties/reports/" +
                self.archive +
                "/archives/" +
                id
        );
        window.location.href = url;
        self.SSAlertService.success("Report downloaded successfully.");
        return false;
    }

    filterReport() {
        const self = this;
        if (self.property_selected == "") {
            self.property_selected = "all";
        }

        self.getPropertyAccountsData();
    }

    toggleSelect() {
        const self = this;
        angular.forEach(self.report_data, function (item) {
            item.same_date = event.target.checked;
        });
    }

    generateArchivePdfReport(isGenerateAllGreenExcel = false) {
        const self = this;
        self.SSAlertService.clear();

        if (!self.reportType) return;
        if (isGenerateAllGreenExcel) {
            if ($("input[name='child[]']:checked") &&
                    $("input[name='child[]']:checked").length &&
                    $("input[name='child[]']:checked").length > 10) {
                self.SSAlertService.warning("Maximum 10 instruments can be processed at a time.");
                return false;
            }
        }

        self.isAllGreenExcel = isGenerateAllGreenExcel;
        self.showGeneratePDF = true;
        self.property_bank_in_date = "";
        $("#generatePDFModal").modal("show");
    }

    _generateArchivePdfReport(isAllGreenExcel = false) {
        const self = this;

        self.errorMessage = false;
        self.child = [];
        $("input[name='child[]']:checked").each(function () {
            if ($(this).val() != "" && $(this).val() != ",")
                self.child.push($(this).val());
            var val = $(this).val();
            jQuery.each(self.report_data, function (i, e) {
                if (typeof e != "undefined" && e.instrument_id == val) {
                    self.report_data.splice(i, 1);
                }
            });
        });
        if (self.child.length == 0) {
            self.SSAlertService.danger("Please select any/all record(s).");
            return false;
        }

        if (typeof self.property_selected_from_date == "undefined") {
            self.property_selected_from_date = "";
        }
        if (typeof self.property_selected_to_date == "undefined") {
            self.property_selected_to_date = "";
        }
        if (typeof self.property_selected_to_date == "undefined") {
            self.property_bank_in_date = "";
        }

        let tempUrl = "sec/developer/properties/reports/" +
        self.reportType +
            (isAllGreenExcel? "/export-excel-bil-all-green" : "/generate-pdf") + "?selected_property=" +
        self.property_selected +
        "&from_date=" +
        self.property_selected_from_date +
        "&to_date=" +
        self.property_selected_to_date +
        "&instrument_idz=" +
        self.child +
        "&property_account=" +
        self.property_account_selected;
        if (self.property_bank_in_date!= "") {
            tempUrl += "&bank_in_date=" + self.property_bank_in_date;
        }
        let url = self.SSHttpService.getApiURL(tempUrl);
        window.location.href = url;
        self.hideModals();
        self.SSAlertService.success("PDF generated successfully.");

    }

    getPropertyAccountsData() {
        const self = this;
        let url =
            "sec/developer/properties/" +
            self.property_selected +
            "/get-property-account";
        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (response && response.data) {
                if (response.data.propertyAccount) {
                    self.propertyAccounts = response.data.propertyAccount;
                    if (response.data.propertyAccount.length) {
                        self.property_account_selected =
                            response.data.propertyAccount[0].id;
                    }
                }
            }
        });
    }
}

PropertyReportsController.$inject = [
    "$window",
    "$http",
    "SSHttpService",
    "SSUtilService",
    "SSAlertService",
    "SSConfigService",
    "SSUserService",
    "SSConfirmationService",
    "$timeout",
];
app.controller("PropertyReportsController", PropertyReportsController);
